import script from "./CompletenessAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletenessAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./CompletenessAnalysis.vue?vue&type=style&index=0&id=731a79c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-731a79c1"]])

export default __exports__